if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        
        const configurator = this.closest('.shopify-section').querySelector('product-configurator');
        this.hasMultiVariants = configurator ? true : false;

        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.useParentId = this.dataset.useParentId === 'true' || this.dataset.useParentId === undefined;
      }

      addFormDataWithoutFiles(formData) {
        // Add all form inputs except file inputs (including those with form attribute)
        const formId = this.form.getAttribute('id');
        const formInputs = document.querySelectorAll(`input[form="${formId}"], select[form="${formId}"], textarea[form="${formId}"], #${formId} input, #${formId} select, #${formId} textarea`);
        
        formInputs.forEach((input, index) => {
          if (input.type !== 'file' && input.name) {
            // Skip quantity inputs from configurator containers with 0 values
            if (input.name === 'quantity' && input.value === '0') {
              const isInConfigurator = input.closest('[data-product-container]');
              if (isInConfigurator) {
                return;
              }
            }
            
            if (input.type === 'checkbox' || input.type === 'radio') {
              if (input.checked) {
                formData.append(input.name, input.value);
              }
            } else {
              formData.append(input.name, input.value);
            }
          }
        });
      }

      handleMultipleFileUploads(formData) {
        // Find all file inputs associated with this form (including those with form attribute)
        const formId = this.form.getAttribute('id');
        const fileInputs = document.querySelectorAll(`input[type="file"][form="${formId}"], #${formId} input[type="file"]`);
        
        fileInputs.forEach((fileInput, inputIndex) => {
          if (fileInput.files && fileInput.files.length > 0) {
            // Add each file as a separate property
            Array.from(fileInput.files).forEach((file, fileIndex) => {
              const propertyName = fileInput.name.replace('[File]', `[File ${fileIndex + 1}]`);
              formData.append(propertyName, file);
            });
          }
        });
      }

      addMultipleVariantsToFormData(formData) {
        const configurator = this.closest('.shopify-section').querySelector('product-configurator');
        if (!configurator) {
          return;
        }

        // Get all product containers from the configurator
        const productContainers = configurator.querySelectorAll('[data-product-container]');
        const selectedVariantIds = [];
        
        productContainers.forEach((container, index) => {
          const variantIdInput = container.querySelector('input[name="product_variant_id"]');
          
          if (variantIdInput) {
            const variantId = variantIdInput.value;
            let quantity = 0;
            
            // Check for quantity input first
            const quantityInput = container.querySelector('input[type="number"]');
            if (quantityInput) {
              quantity = parseInt(quantityInput.value, 10);
            } else {
              // Check for radio button selection
              const selectedRadio = container.querySelector('input[type="radio"]:checked');
              if (selectedRadio) {
                quantity = parseInt(selectedRadio.dataset.quantity, 10);
              }
            }
            
            // Only add items with quantity > 0 and valid variant ID
            if (quantity > 0 && variantId) {
              formData.append(`items[${index + 1}][quantity]`, quantity);
              formData.append(`items[${index + 1}][id]`, variantId);
              formData.append(`items[${index + 1}][parent_id]`, formData.get('id'));
              selectedVariantIds.push(variantId);
            }
          }
        });
        
        // Add _config property with all selected variant IDs separated by dashes
        if (selectedVariantIds.length > 0) {
          const configValue = selectedVariantIds.join('-');
          formData.append('properties[_config]', configValue);
        }
      }


      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        
        // Add all form data except files
        this.addFormDataWithoutFiles(formData);
        
        // Handle multiple file uploads
        this.handleMultipleFileUploads(formData);
        
        // Add multiple variants if configurator is present
        if (this.hasMultiVariants) {
          this.addMultipleVariantsToFormData(formData);
        }
        
        // Add sections data
        const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              if (response.status === 422 && this.dataset.continueSelling) {
                window.location = window.routes.cart_url;
                return;
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
